module.exports = __webpack_public_path__ + "media/images/pic/saska/elastic-8d8e03ccf60d8129b96f2212c956f8c8.png";